import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  BaseDaoService,
  NodePath,
  OptimizedDataStatus,
  OrgInfo,
  REF_MODEL_STORE,
  RefModelList,
  RefModelStoreService,
  Refmodel,
  SalesForceData,
  User,
  composeRequestParams,
  handleError
} from '@q9elements/ui-kit/common';
import {OptimizeStatusResponse} from '@q9elements/ui-kit/refmodels';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RefModelService extends BaseDaoService {
  constructor(private rmeStore: RefModelStoreService) {
    super();
  }

  public getRefModelMeta(refModelId: string): Observable<SalesForceData | Refmodel> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/data`;

    return this.http.get<SalesForceData>(url).pipe(handleError());
  }

  public getOptimizeAssignees(refModelId: string, pattern: string): Observable<User[] | any> {
    // const params = new HttpParams().append('search', pattern);
    const params = pattern ? composeRequestParams({pattern}) : {};
    const url = `${this.apiUrl}/refmodel/${refModelId}/optimizeAssignees`;

    return this.http.get<User[]>(url, {params}).pipe(handleError());
  }

  public getOptimizeStatuses():
    | Observable<OptimizeStatusResponse[]>
    | Observable<OptimizedDataStatus[]> {
    const params = new HttpParams().append('returnAll', true);
    const url = `${this.apiUrl}/optimize-status`;

    return this.http.get(url, {params}).pipe(
      catchError(err => {
        console.log(err);

        return of([]);
      }),
      tap((data: OptimizedDataStatus[]) =>
        this.rmeStore.set<OptimizedDataStatus[]>(REF_MODEL_STORE.OPTIMIZE_STATUSES, data)
      )
    );
  }

  public fetchNodePath(
    refModelId: string,
    nodeId?: string
  ): Observable<NodePath[]> | Observable<[]> {
    if (!nodeId) {
      this.rmeStore.set(REF_MODEL_STORE.NODE_PATH, []);
      return of([]);
    } else {
      const url = `${this.apiUrl}/refmodel/${refModelId}/node/${nodeId}/path`;
      return this.http
        .get(url)
        .pipe(tap((data: NodePath[]) => this.rmeStore.set(REF_MODEL_STORE.NODE_PATH, data)));
    }
  }

  public fetchRefModelMeta(refModelId): Observable<SalesForceData> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/data`;

    return this.http.get<SalesForceData>(url).pipe(
      tap((refModel: SalesForceData) => {
        this.rmeStore.set(REF_MODEL_STORE.REF_MODEL, refModel);
      })
    );
  }

  public getRefModelsList(external = false, limit?: number): Observable<RefModelList> {
    let params = new HttpParams().set('external', String(external));

    if (limit) {
      params = params.append('limit', String(limit));
    }

    const url = `${this.apiUrl}/refmodels`;

    return this.http.get<RefModelList>(url, {params});
  }

  getSFOrgInfoDataByRefmodel(refModelId: string): Observable<OrgInfo> {
    const url = `${this.apiUrl}/refmodel/${refModelId}/orgInfo`;

    return this.http.get(url).pipe(
      tap((orgInfo: OrgInfo) => {
        if (orgInfo) {
          this.rmeStore.set(REF_MODEL_STORE.LINK_TYPE, orgInfo.linkType);
          this.rmeStore.set(REF_MODEL_STORE.ORG_INFO, orgInfo);
        }
      })
    );
  }
}
